module.exports = __webpack_public_path__ + "img/AQM65.7f3ac96c.png";